import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { formatPhoneNumber, stripLeadingOnesAndZeros, stripNonNumerics } from '@/helpers';
import { GuestInfoForm } from '@/store/checkout';
import { GuestInfoField } from '@/services/checkout/checkout.service';
import { OrderWithContext } from '@/models';

@Component({
  name: 'CmgCheckoutGuestInfoForm',
})
export default class CmgCheckoutGuestInfoForm extends Vue {
  sentCheckoutEvent = false;

  get form(): GuestInfoForm {
    return this.$appStore.state.checkout.guest.info;
  }

  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  mounted() {
    const numberValue = this.$appStore.state.checkout.guest.info.phoneNumber.value;
    if (!this.$appStore.state.checkout.guest.info.phoneNumber.formatted && numberValue) {
      this.$appStore.state.checkout.guest.info.phoneNumber.formatted = this.formatPhoneNumber(numberValue);
    }
  }

  formatPhoneNumber(value: string): string {
    return formatPhoneNumber(value);
  }

  sanitizePhoneNumber(value: string): string {
    return stripLeadingOnesAndZeros(stripNonNumerics(value));
  }

  validateField(field: GuestInfoField) {
    this.validateForm(field);
  }

  onBlurContactInfoField(): void {
    if (this.isGuestInfoComplete() && !this.sentCheckoutEvent && this.order) {
      this.sentCheckoutEvent = true;
      this.$services.googleAnalytics.sendEcommerceCheckoutEvent(this.order, 'contact info', 3);
    }
  }

  onBlurPhoneNumberField(event: any): void {
    this.onBlurContactInfoField();
    if (event.target.value) {
      this.setDeliveryPhoneNumbers(event.target.value);
    }
  }

  setDeliveryPhoneNumbers(phoneNumber: string) {
    const profile = this.$appStore.state.customer.profile;
    if (profile && profile.isGuest) {
      this.$services.checkout.setGuestInfoPhoneNumber(phoneNumber);
    }

    this.$services.order.setOrderPhoneNumber(phoneNumber);
    this.$services.checkout.setDeliveryPhoneNumber(phoneNumber);
  }

  private validateForm(field: GuestInfoField) {
    this.$services.checkout.validateGuestInfo([field]);
  }

  private isGuestInfoComplete(): boolean {
    return !!this.form.customerName.value &&
      !!this.form.phoneNumber.value &&
      !!this.form.email.value;
  }
}
